import * as React from 'react';

const s = require('./filters_container.css');

export interface IFiltersContainerProps {
  children?: React.ReactNode;
}

export const FiltersContainer = (props: IFiltersContainerProps) => (
  <div className={s['c-filters-container']}>{props.children}</div>
);
